import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from 'react-icons/fa';
import { useSettings } from '../hooks/useApi';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  const { data: settings } = useSettings();

  const address = settings?.address || '44/246 ซอยวิภาวดีรังสิต 41 แยก 1 แขวงสนามบิน เขตดอนเมือง กรุงเทพฯ 10210';
  const socialLinks = {
    facebook: settings?.facebook_url || '#',
    instagram: settings?.instagram_url || '#',
    linkedin: settings?.linkedin_url || '#',
    youtube: settings?.youtube_url || '#',
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const offset = 72;
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/logo-white.png" alt="KBY Interactive" style={{ height: '50px', objectFit: 'contain' }} />
            </div>
            <p className="footer__brand-desc">
              {settings?.footer_tagline || 'A creative technology company crafting immersive digital and interactive experiences for brands worldwide.'}
            </p>
            <div className="footer__socials">
              <a href={socialLinks.facebook} className="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href={socialLinks.instagram} className="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href={socialLinks.linkedin} className="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href={socialLinks.youtube} className="footer__social-link" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="footer__links-group">
            <h4>{t('footer.nav')}</h4>
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}>{t('nav.home')}</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('about'); }}>{t('nav.about')}</a>
            <a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>{t('nav.services')}</a>
            <a href="#portfolio" onClick={(e) => { e.preventDefault(); scrollTo('portfolio'); }}>{t('nav.portfolio')}</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>{t('nav.contact')}</a>
          </div>

          {/* Contact Info */}
          <div className="footer__links-group">
            <h4>{t('footer.contact')}</h4>
            <a href={`mailto:${settings?.contact_email || 'thitisquall@gmail.com'}`}>
              {settings?.contact_email || 'thitisquall@gmail.com'}
            </a>
            <a href={`tel:${settings?.phone || '+66637824516'}`}>
              {settings?.phone || '063-782-4516'}
            </a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}>
              {address}
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            {settings?.footer_copyright || '© 2026 KBY Interactive Co., Ltd. All rights reserved.'}
          </p>
          <div className="footer__bottom-links">
            <a href="/privacy">{t('footer.privacy')}</a>
            <a href="/terms">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
